<template>
  <div class="site-live" v-loading="loading" v-if="siteData">
    <el-row>
      <el-col :span="8">
        <div class="info">
          <span class="label">名称</span>
          <span class="value">{{ siteData.name }}</span>
        </div>

        <div class="info">
          <span class="label">编码</span>
          <span class="value">{{ siteData.code }}</span>
        </div>

        <div class="info">
          <span class="label">分组设置</span>
          <span class="value"
            >[{{ siteData.entitySetting.groupByAttrs.join(",") }}]</span
          >
        </div>

        <div class="info">
          <span class="label">数据条数控制</span>
          <span class="value">
            <el-checkbox
              disabled
              v-model="siteData.entitySetting.limitAble"
            ></el-checkbox>
          </span>
        </div>

        <div class="info">
          <span class="label">默认返回条数</span>
          <span class="value">{{ siteData.entitySetting.queryMaxSize }}</span>
        </div>
      </el-col>
      <el-col :span="16">
        <span class="label block">数据详情</span>
        <span class="value block">{{ siteData.description }}</span>
      </el-col>
    </el-row>
    <div class="table-label">
      <span class="label">属性列表</span>
    </div>
    <el-table
      style="margin-bottom: 8px"
      :data="siteData.entitySetting.columnSettings"
      border
    >
      <el-table-column
        label="列名"
        prop="columnName"
        min-width="110"
      ></el-table-column>
      <el-table-column
        label="类型"
        prop="type"
        min-width="80"
      ></el-table-column>
      <el-table-column
        label="属性名"
        prop="attrName"
        min-width="140"
      ></el-table-column>
      <el-table-column
        label="属性表达式"
        prop="attrExpression"
        min-width="120"
      ></el-table-column>
      <el-table-column
        label="实体列类型"
        prop="attrType"
        min-width="80"
      ></el-table-column>
      <el-table-column
        label="描述"
        prop="description"
        min-width="200"
      ></el-table-column>
      <el-table-column label="查询过滤" #default="{row}" width="370">
        <el-checkbox-group v-model="row.queryFilters" size="mini">
          <el-checkbox-button
            disabled
            v-for="f in filters"
            :label="f"
            :key="f"
            >{{ f }}</el-checkbox-button
          >
        </el-checkbox-group>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "SiteLive",
  props: {
    propData: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      filters: ["RANGE", "IN", "NOT_IN", "NULL", "DISTINCT"],
      siteData: null
    };
  },
  watch: {
    propData: {
      immediate: true,
      handler() {
        this.getData();
      }
    }
  },
  methods: {
    getData() {
      this.loading = true;
      this.$http
        .get(`/gavial/v1/di/detail?id=${this.propData.id}`)
        .then(res => {
          this.siteData = res.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
.site-live {
  height: 100%;
  padding: 0 16px;
  overflow: auto;
  .info {
    margin-bottom: 14px;
  }
  .label {
    font-size: 15px;
    line-height: 30px;
    color: #2e2e2e;
    font-weight: bold;
    &.block {
      display: block;
    }
  }
  .value {
    margin-left: 14px;
    font-size: 16px;
    line-height: 32px;
    color: #2e2e2e;
    &.block {
      box-sizing: border-box;
      display: block;
      height: 180px;
      overflow: auto;
      margin: 10px 0;
      padding: 15px;
      border: 1px solid #eee;
      line-height: 20px;
    }
  }
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner,
  .el-checkbox-button.is-disabled.is-checked .el-checkbox-button__inner {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    box-shadow: -1px 0 0 0 #8cc5ff;
  }
  .table-label {
    padding-top: 8px;
    margin-bottom: 8px;
    border-top: 1px solid #eee;
  }
}
</style>
